import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useMediaQuery,
} from "@mui/material";
import GreenButton from "../../../components/GreenButton/GreenButton";
import BlueButton from "../../../components/BlueButton/BlueButton";
import MessageModals from "../../../components/MessageModals/MessageModals";
import AddPhoto from "./../../../assets/add-photo.png";
import DeleteBtn from "./../../../assets/delete-icon.png";
import api from "../../../utils/api";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";

const Sliders = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const [view, setView] = useState("App");
  const [openDelete, setOpenDelete] = useState(false);
  const [image, setImage] = useState(null);
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("32"); // Default to Egypt (ID: 32)
  const [countries, setCountries] = useState([]);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getCountries();
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      getSliders();
    }
  }, [selectedCountry, view]);

  const getCountries = async () => {
    try {
      const res = await api.get("/countries");
      setCountries(res.data.data);
      // No need to set default country as it's already set to Egypt (32)
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  const getSliders = async () => {
    setLoading(true);
    try {
      // Updated to include flag=slider parameter
      const res = await api.get(
        `/slides?flag=slider&type=${view.toLowerCase()}&country_id=${selectedCountry}`
      );
      setSliders(res.data.data || []);
    } catch (error) {
      console.error("Error fetching sliders:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  const handleSubmit = async () => {
    if (!image || !(image instanceof File)) {
      toast.error("الرجاء اختيار صورة");
      return;
    }

    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("image", image);
      formData.append("country_id", selectedCountry.toString());
      formData.append("type", view.toLowerCase());
      formData.append("flag", "slider"); // Added flag parameter

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      await api.post("/slides", formData, config);
      toast.success("تم إضافة الصورة بنجاح");
      getSliders();
      setImage(null);
    } catch (error) {
      console.error("Error submitting slider:", error);
      toast.error("حدث خطأ أثناء إضافة الصورة");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteSlide = async (slideId) => {
    try {
      await api.delete(`/slides/${slideId}`);
      toast.success("تم حذف الصورة بنجاح");
      getSliders();
      setOpenDelete(false);
    } catch (error) {
      console.error("Error deleting slider:", error);
      toast.error("حدث خطأ أثناء حذف الصورة");
    }
  };

  return (
    <div className="departments-container">
      <div className="actions-container">
        <div className="btns-container">
          <GreenButton
            text="التطبيق"
            size={isMobile ? "full" : isTablet ? "fit" : "medium"}
            variant={view === "App" ? "fill" : "outlined"}
            onClick={() => setView("App")}
          />
          <GreenButton
            text="الموقع"
            size={isMobile ? "full" : isTablet ? "fit" : "medium"}
            variant={view === "Web" ? "fill" : "outlined"}
            onClick={() => setView("Web")}
          />
        </div>
      </div>

      <div className="banners">
        <div className="banners-container">
          <div
            style={{
              background: "white",
              padding: isMobile ? "10px" : "16px 30px",
              borderRadius: "15px 15px 0px 0px",
            }}
          >
            <FormControl sx={{ width: isMobile ? "100%" : "375px" }}>
              <InputLabel
                htmlFor="country-select"
                shrink
                sx={{
                  background: "white",
                  transformOrigin: "right top",
                  transform: "translate(14px, -9px) scale(0.75)",
                  right: 24,
                  left: "auto",
                  paddingLeft: "4px",
                  paddingRight: "4px",
                }}
              >
                اختر البلد
              </InputLabel>
              <Select
                value={selectedCountry}
                onChange={(e) => setSelectedCountry(e.target.value)}
                displayEmpty={true}
                sx={{ borderRadius: "8px" }}
              >
                {countries.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.name_ar}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div
            className="imgs-container"
            style={{ borderRadius: "0px 0px 15px 15px", position: "relative" }}
          >
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="form-img">
                  <label htmlFor="image" className="img-control">
                    <img
                      src={
                        image instanceof File
                          ? URL.createObjectURL(image)
                          : AddPhoto
                      }
                      alt=""
                      className={image ? "is-img" : ""}
                    />
                    {!image && <span>اضافة صورة</span>}
                  </label>
                  <input
                    type="file"
                    id="image"
                    onChange={handleImageChange}
                    accept="image/*"
                  />
                </div>

                {sliders.map((slider) => (
                  <div key={slider.id} className="img-container">
                    <img src={slider.image} alt="" />
                    <img
                      src={DeleteBtn}
                      alt=""
                      className="delete-btn"
                      onClick={() => {
                        setItemToDelete(slider);
                        setOpenDelete(true);
                      }}
                    />
                  </div>
                ))}
              </>
            )}
          </div>
        </div>

        <div className="action-container">
          <BlueButton
            text="حفظ"
            size="medium"
            variant="fill"
            loading={isSubmitting}
            disabled={isSubmitting || !image}
            onClick={handleSubmit}
          />
        </div>
      </div>

      <MessageModals
        open={openDelete}
        currentView="delete"
        route={`/slides/${itemToDelete?.id}`}
        text="تم حذف الصورة بنجاح"
        onClose={() => {
          setOpenDelete(false);
          setItemToDelete(null);
        }}
        onDataChange={getSliders}
        onConfirm={() => handleDeleteSlide(itemToDelete?.id)}
      />
    </div>
  );
};

export default Sliders;
